import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import WhatsNewModal from './WhatsNewModal';

import { getReleaseNotes } from '@/services/releaseNotesApi';

const WhatsNewContext = createContext({
  hasUnread: false,
  openWhatsNew: () => {},
});

export const useWhatsNew = () => useContext(WhatsNewContext);

export const WhatsNewProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const returnFocusRef = useRef(null);

  useEffect(() => {
    let active = true;
    getReleaseNotes({ perPage: 1 })
      .then((result) => {
        if (active) setHasUnread(Boolean(result.has_unread));
      })
      .catch(() => {
        // History availability must never interfere with the admin shell.
      });
    return () => { active = false; };
  }, []);

  const openWhatsNew = useCallback((returnFocusElement) => {
    returnFocusRef.current = returnFocusElement instanceof HTMLElement
      ? returnFocusElement
      : document.activeElement;
    setOpen(true);
  }, []);
  const handleOpenChange = useCallback((nextOpen) => {
    setOpen(nextOpen);
    if (!nextOpen) {
      window.requestAnimationFrame(() => returnFocusRef.current?.focus());
    }
  }, []);
  const handleSeen = useCallback(() => setHasUnread(false), []);
  const value = useMemo(() => ({ hasUnread, openWhatsNew }), [hasUnread, openWhatsNew]);

  return (
    <WhatsNewContext.Provider value={value}>
      {children}
      <WhatsNewModal open={open} onOpenChange={handleOpenChange} onSeen={handleSeen} />
    </WhatsNewContext.Provider>
  );
};
